import { axiosBaseQuery } from '@client';
import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { SofEventsExtractorRequestRegistrationForm } from './models';

export type RegisterSofEventsExtractorRequestTrigger = ReturnType<
  typeof useRegisterSofEventsExtractorRequestMutation
>[0];

export const sofEventsExtractorApi = createApi({
  baseQuery: axiosBaseQuery(),
  reducerPath: 'hl-ai-sof-events-extractor-api',
  endpoints: (build) => ({
    registerSofEventsExtractorRequest: build.mutation<
      void,
      SofEventsExtractorRequestRegistrationForm
    >({
      query: (data) => ({
        url: `/secured/sof-events-extractor/register-request`,
        method: 'POST',
        data
      })
    })
  })
});

export const { useRegisterSofEventsExtractorRequestMutation } =
  sofEventsExtractorApi;
